// extracted by mini-css-extract-plugin
export default {"content":"BuildingAttachmentModal__content--CikHh"};